// extracted by mini-css-extract-plugin
module.exports = {"poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","blue":"#5291c0"};